/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'ordercomplaint': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M516.298 593.812c-24.968 0-45.332-20.261-45.332-45.332V299.208c0-24.968 20.261-45.229 45.332-45.229 25.07 0 45.434 20.261 45.434 45.23V548.48c-.103 25.07-20.466 45.332-45.434 45.332zm0 167.102c-29.675 0-53.825-24.047-53.825-53.927 0-29.573 24.15-53.825 53.825-53.825 29.777 0 53.825 24.15 53.825 53.825-.103 29.777-24.15 53.927-53.825 53.927z"/><path pid="1" d="M516.093 949.607c-243.44 0-441.547-198.107-441.547-441.547S272.654 66.513 516.093 66.513 957.64 264.621 957.64 508.06 759.532 949.607 516.093 949.607zm0-827.939c-213.048 0-386.392 173.345-386.392 386.392 0 213.048 173.344 386.392 386.392 386.392S902.485 721.108 902.485 508.06c0-213.047-173.344-386.392-386.392-386.392z"/>'
  }
})
